// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"452":"47900f6147794783b539","896":"741b5d9697205fd33bae"}[chunkId] + ".js";
};